var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "video",
    _vm._b({ class: _vm.classes }, "video", _vm.videoAttrs, false),
    [_c("source", { attrs: { src: _vm.staticUrl, type: "video/mp4" } })]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }